import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ViewService } from 'api';
import { firstValueFrom } from 'rxjs';

export const LicenseAgreementConfirmedGuard: CanActivateFn = async (_route, state) => {
  const viewService = inject(ViewService);
  const router = inject(Router);

  try {
    await firstValueFrom(viewService.getLicenseAgreementApproval());
  } catch (err) {
    return new RedirectCommand(
      router.createUrlTree(['/license'], {
        queryParams: { returnUrl: state.url },
      }),
    );
  }

  return true;
};
